import { apiGet, apiPost, apiDelete } from './api';
import type {
  Device,
  CreateDeviceRequest,
  DeviceProvisioningResult,
  BulkProvisionRequest,
  BulkProvisionResult,
} from '../types/device';

export async function getDevices(customerId?: string): Promise<Device[]> {
  const path = customerId ? `/devices?customer_id=${customerId}` : '/devices';
  const response = await apiGet<{ devices: Device[] }>(path);
  return response.devices;
}

export async function getDevice(deviceId: string): Promise<Device> {
  return apiGet<Device>(`/devices/${deviceId}`);
}

export async function provisionDevice(data: CreateDeviceRequest): Promise<DeviceProvisioningResult> {
  return apiPost<DeviceProvisioningResult>('/devices', data);
}

export async function deprovisionDevice(deviceId: string): Promise<void> {
  await apiDelete(`/devices/${deviceId}`);
}

export async function bulkProvisionDevices(
  data: BulkProvisionRequest,
): Promise<BulkProvisionResult> {
  return apiPost<BulkProvisionResult>('/devices/bulk', data);
}
